package com.trevorwiebe.timesheet.loads.presentation.admin

import com.trevorwiebe.timesheet.core.domain.Util
import com.trevorwiebe.timesheet.loads.domain.model.Load
import com.trevorwiebe.timesheet.loads.domain.model.LoadStop
import com.trevorwiebe.timesheet.loads.domain.model.drops
import com.trevorwiebe.timesheet.loads.domain.model.pickups
import com.trevorwiebe.timesheet.mileage.domain.model.Location
import com.trevorwiebe.timesheet.mileage.domain.model.cityState

object CarrierLoadShareText {

    fun build(load: Load, locations: List<Location>): String = buildString {
        append("Load Confirmation")
        if (load.loadNumber.isNotBlank()) append("\nLoad #: ${load.loadNumber}")
        append("\nPickup date: ${Util.toDayOfWeekMonthDay(load.pickupDate)}")
        load.pickups.forEach {
            append("\nPickup: ${stopText(it, locations)}")
            mapLine(it, locations)?.let { line -> append("\n$line") }
        }
        load.drops.forEach {
            append("\nDrop: ${stopText(it, locations)}")
            mapLine(it, locations)?.let { line -> append("\n$line") }
        }
        if (load.commodity.isNotBlank()) append("\nCommodity: ${load.commodity}")
        if (load.po.isNotBlank()) append("\nPO #: ${load.po}")
        if (load.orderNumber.isNotBlank()) append("\nOrder #: ${load.orderNumber}")
        if (load.customerRequirements.isNotBlank()) append("\nRequirements: ${load.customerRequirements}")
    }

    private fun stopText(stop: LoadStop, locations: List<Location>): String {
        val location = locations.firstOrNull { it.id == stop.locationId }
        val cityState = location?.cityState.orEmpty()
        val name = location?.name ?: "—"
        return if (cityState.isEmpty()) name else "$name ($cityState)"
    }

    private fun mapLine(stop: LoadStop, locations: List<Location>): String? {
        val location = locations.firstOrNull { it.id == stop.locationId } ?: return null
        val lat = location.latitude ?: return null
        val lng = location.longitude ?: return null
        val label = location.name.trim()
        val labelSuffix = if (label.isNotEmpty()) "(${Util.percentEncode(label)})" else ""
        return "Map: https://maps.google.com/?q=$lat,$lng$labelSuffix"
    }
}
